import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";
import { logoutUser } from "store/actions";
import { fetchUserDetails } from "services/userProfile/userProfileService";
import user1 from "../../../assets/images/users/avatardp.png";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const response = await fetchUserDetails();
        // The profile API returns a single object (older code expected an array), so accept both
        const profile = Array.isArray(response?.data) ? response.data[0] : response?.data;
        if (!response?.isError && profile) {
          const fullName = [profile.first_name, profile.last_name].filter(Boolean).join(" ");
          setusername(profile.displayname || profile.username || fullName || "");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    getUserDetails();
  }, [props.success]);

  const handleLogout = () => {
    dispatch(logoutUser(navigate));
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span
            className="d-inline-block align-middle ms-2 me-1 fw-medium text-truncate"
            style={{ maxWidth: 150 }}
            title={username}
          >
            {username}
          </span>
          <i className="mdi mdi-chevron-down d-inline-block align-middle" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/profile">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}
          </DropdownItem>
          <DropdownItem tag={Link} to="/reset-password">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Change Password")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <DropdownItem onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);